export const GET_2359_REPORTS_REQUEST = 'GET_2359_REPORTS_REQUEST' as const;
export const GET_2359_REPORTS_SUCCESS = 'GET_2359_REPORTS_SUCCESS' as const;
export const GET_2359_REPORTS_ERROR = 'GET_2359_REPORTS_ERROR' as const;
export const GET_2359_REPORTS_FILTER = 'GET_2359_REPORTS_FILTER' as const;

export const fieldsNames = [
  'tripId',
  'delayInStation',
  'tripStatus',
  'currentStatusSetDt',
  'vehicleLicensePlate',
  'trailerLicensePlate',
  'driver',
  'driverPhone',
  'driverDocument',
  'forwarder',
  'forwarderPhone',
  'forwarderDocument',
  'arrivalDate',
  'entrySecurityMessage',
];
